var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBatteryCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 14.5c0-.41.34-.75.75-.75.59 0 .72-.09.73-.09.02-.06.02-.41.02-.66v-2c0-.25 0-.59-.04-.68-.01.01-.16-.07-.71-.07-.41 0-.75-.34-.75-.75s.34-.75.75-.75c2.08 0 2.25 1.02 2.25 2.25v2c0 1.23-.17 2.25-2.25 2.25-.41 0-.75-.34-.75-.75zM9.51 16.57a.756.756 0 0 1-.08-1.06l2.08-2.43c.03-.09 0-.17-.02-.21a.238.238 0 0 0-.22-.12h-2.3c-.63 0-1.2-.33-1.52-.87-.32-.54-.32-1.2 0-1.75L9.4 7.55a.75.75 0 0 1 1.2.9l-1.89 2.5c-.01.03.03.12.05.17.03.05.09.12.22.12h2.3c.63 0 1.2.33 1.52.87.32.54.32 1.2 0 1.75-.02.04-.05.08-.08.11l-2.14 2.5a.752.752 0 0 1-1.07.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 14v-4c0-4.41 1.34-5.75 5.75-5.75.41 0 .75.34.75.75s-.34.75-.75.75c-3.57 0-4.25.68-4.25 4.25v4c0 3.57.68 4.25 4.25 4.25.41 0 .75.34.75.75s-.34.75-.75.75c-4.41 0-5.75-1.34-5.75-5.75zM12.25 19c0-.41.34-.75.75-.75 3.57 0 4.25-.68 4.25-4.25v-4c0-3.57-.68-4.25-4.25-4.25-.41 0-.75-.34-.75-.75s.34-.75.75-.75c4.41 0 5.75 1.34 5.75 5.75v4c0 4.41-1.34 5.75-5.75 5.75-.41 0-.75-.34-.75-.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBatteryCharging);
export default __webpack_public_path__ + "static/media/vuesax-outline-battery-charging.c6121c03791153b202acf75b5a10fc0f.svg";
export { ForwardRef as ReactComponent };